var t = require("stimulus");

module.exports = function (t) {
  function e() {
    t.apply(this, arguments);
  }

  t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e;
  var o = {
    targets: {
      configurable: !0
    }
  };
  return o.targets.get = function () {
    return ["source"];
  }, e.prototype.connect = function () {
    this.closeAllBefore = this.data.get("closeAllBefore") || "false", this.classToToggle = this.data.get("classToToggle") || "dnone";
  }, e.prototype.toggle = function (t) {
    t.preventDefault(), "true" === this.closeAllBefore && this.closeOpenElements(), this.toggleClassElement(t.target.closest("div"));
  }, e.prototype.closeOpenElements = function () {
    var t = this.classToToggle;
    this.sourceTargets.forEach(function (e) {
      e.classList.add(t);
    });
  }, e.prototype.toggleClassElement = function (t) {
    t.querySelector('[data-target="accordion.source"]').classList.toggle(this.classToToggle);
  }, Object.defineProperties(e, o), e;
}(t.Controller);